import { Button } from '@repo/ui'
import { useTranslation } from 'react-i18next'
import { DownloadIcon24 } from '@repo/ui/icons'
import useBefehlsnachrichtPdfDownload from '@/features/befehlsnachrichten/hooks/useBefehlsnachrichtPdfDownload'
import { BfnStoreDataEntry } from '@/store/useBfnStore'
import useOnlineDetection from '@/features/offline/hooks/useOnlineDetection'

export interface BfnExportAsPdfActionProps {
  data: BfnStoreDataEntry
  'data-testid': string
}

export default function BfnExportAsPdfAction({
  data,
  'data-testid': testId
}: Readonly<BfnExportAsPdfActionProps>) {
  const { t } = useTranslation('bfnDetails')
  const pdfDownloadMutation = useBefehlsnachrichtPdfDownload(
    data.befehlsnachricht.id
  )
  const isOnline = useOnlineDetection()

  const onClick = () => {
    pdfDownloadMutation.mutate({
      abruftoken: data.abruftoken,
      manuellWiderrufenAt: data.manuellWiderrufenAt
    })
  }

  return (
    <Button
      key="export-to-pdf"
      variant="secondary-solid"
      data-testid={`${testId}-button`}
      onClick={onClick}
      disabled={!isOnline || pdfDownloadMutation.isPending}
    >
      <DownloadIcon24
        className="shrink-0"
        data-testid={`${testId}-button-icon`}
      />
      <span className="pl-0.5" data-testid={`${testId}-button-text`}>
        {t('actions.export_as_pdf')}
      </span>
    </Button>
  )
}
